import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSign24H = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#prefix__clip0_2_1059)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8.75 11.45l9.15-6.142M31.25 11.45L22.1 5.308",
				stroke: "#3C527D",
				strokeWidth: 1.951,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.75 11.45H1.25V37.7h37.5V11.45zM20 6.45a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
				stroke: "#3C527D",
				strokeWidth: 1.951,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.439 29.101H7.39v-1.086l2.301-2.313c.68-.696 1.13-1.19 1.352-1.48.221-.291.383-.565.485-.82.102-.257.153-.532.153-.825 0-.403-.121-.72-.363-.952-.243-.231-.577-.348-1.004-.348-.342 0-.673.063-.992.19-.32.126-.689.353-1.108.683l-.775-.946c.497-.419.979-.716 1.447-.891a4.237 4.237 0 011.495-.263c.83 0 1.496.217 1.996.65.5.434.75 1.017.75 1.75 0 .402-.071.784-.216 1.147a4.68 4.68 0 01-.665 1.12c-.3.384-.797.904-1.493 1.559l-1.55 1.501v.061h4.236v1.263zM20.891 27.154H19.69V29.1H18.29v-1.947h-4.077v-1.105l4.077-5.897h1.398v5.811h1.202v1.19zm-2.6-1.19v-2.24c0-.798.02-1.451.061-1.96h-.048a6.945 6.945 0 01-.537.977l-2.216 3.222h2.74zM25.884 20.177l-3.32 8.923h-1.355l3.326-8.923h1.349zM27.55 29.101l3.528-7.647H26.44V20.19h6.171v1.002l-3.51 7.91h-1.55z",
				fill: "#3C527D"
			})
		]
	})
});
export default SvgSign24H;
